import {getData, postData} from './http';

type AdHoc = Core.AdHoc.AdHoc;
type AdHocAvailabilityType = Core.AdHoc.AdHocAvailabilityType;
type AdHocProductTypesRequest = Core.AdHoc.AdHocProductTypesRequest;
type AdHocAvailabilityRequest = Core.AdHoc.AdHocAvailabilityRequest;
type AdHocDetailsGetRequest = Core.AdHoc.AdHocDetailsGetRequest;
type AdHocDetailsGetResponse = Core.AdHoc.AdHocDetailsGetResponse;

const availabilityApiUrl: string = '/api/adhoc/availability';
const detailsApiUrl: string = '/api/adhoc/details';
const promiseCache = new Map();

export function getProductTypes(request: AdHocProductTypesRequest): Promise<AdHocAvailabilityType[]> {
    return postData<any>(`${availabilityApiUrl}/getproducttypes`, request, { logErrors: false })
        .then(data => data ? data.AvailableTypes : []);
}

export function get(request: AdHocAvailabilityRequest): Promise<AdHoc> {
    return postData(`${availabilityApiUrl}/get`, request, { logErrors: false });
}

export function getFromSession(availabilityId: string): Promise<AdHoc> {
    return getData(`${availabilityApiUrl}/getfromsession?availabilityId=${availabilityId}`);
}

export function getDetails(detailsRequest: AdHocDetailsGetRequest): Promise<any> {
    return postData(`${detailsApiUrl}/get`, detailsRequest, { logErrors: false });
}

export function getDetailsFromSession(detailsId: string): Promise<AdHocDetailsGetResponse> {
    return getData(`${detailsApiUrl}/getfromsession?detailsId=${detailsId}`);
}

export function rehydrate(detailsId: string): Promise<AdHocDetailsGetResponse> {
    if (promiseCache.has(detailsId)) {
        return promiseCache.get(detailsId);
    }
    const promise = getDetailsFromSession(detailsId);
    promiseCache.set(detailsId, promise);
    return promise;
}
